import { render, staticRenderFns } from "./CheckboxGroupSections.vue?vue&type=template&id=97c3f6a6"
import script from "./CheckboxGroupSections.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupSections.vue?vue&type=script&lang=js"
import style0 from "./CheckboxGroupSections.vue?vue&type=style&index=0&id=97c3f6a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports